import { type App } from 'vue';
import { createRouter, createWebHistory, type Router } from 'vue-router';

import { routes as bundleRoutes } from '@/modules/pricing/routes';
import { routes as extensionRoutes } from '@/modules/extension/routes';
import { routes as antivirusRoutes } from '@/modules/antivirus/routes';
import { routes as slotsRoutes } from '@/modules/slots/routes';
import { routes as dealsRoutes } from '@/modules/deals/routes';
import { routes as thankPurchaseRoutes } from '@/modules/thank-purchase/routes';
import { routes as notFoundRoutes } from '@/modules/not-found/routes';
import { routes as checkAntispyMainRoutes } from '@/modules/check-antispy-main/routes';
import { routes as checkAntispyTestRoutes } from '@/modules/check-antispy-test/routes';
import { routes as antiSpyEmailRoutes } from '@/modules/anti-spy-email-after-pay/routes';
import { routes as windowsRoutes } from '@/modules/windows/routes';
import { routes as windows3Routes } from '@/modules/windows3/routes';
import { routes as macosRoutes } from '@/modules/macos/routes';
import { routes as dealsLp1001Routes } from '@/modules/deals-lp-1001/routes';
import { routes as dealsLp1002Routes } from '@/modules/deals-lp-1002/routes';
import { routes as extraSlotsRoutes } from '@/modules/extra-slots/routes';
import { routes as subscriptionRoutes } from '@/modules/subscription/routes';
import { routes as subscriptionTestRoutes } from '@/modules/subscription-test/routes';
import { routes as renewalRoutes } from '@/modules/renewal/routes';
import { routes as yunoRoutes } from '@/modules/yuno/routes';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...antivirusRoutes,
    ...bundleRoutes,
    ...extensionRoutes,
    ...slotsRoutes,
    ...dealsRoutes,
    ...checkAntispyMainRoutes,
    ...checkAntispyTestRoutes,
    ...antiSpyEmailRoutes,
    ...thankPurchaseRoutes,
    ...windowsRoutes,
    ...windows3Routes,
    ...macosRoutes,
    ...dealsLp1001Routes,
    ...dealsLp1002Routes,
    ...extraSlotsRoutes,
    ...subscriptionRoutes,
    ...subscriptionTestRoutes,
    ...renewalRoutes,
    ...yunoRoutes,
    // must be last
    ...notFoundRoutes,
  ],
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

export default async function setupRouter(app: App): Promise<Router> {
  app.use(router);

  await router.isReady();

  return router;
}
